var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-3",class:_vm.classes},[_vm._v(" "+_vm._s(_vm.item.loadText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }